import {
  fetchAccount, updateAccount, updateAdvisorPhoto, deleteAdvisorPhoto,
} from '@/lib/api';
import { apiUrl } from '@/lib/utils/constants';

export default {
  state: {
    firstName: '',
    lastName: '',
    invitationUrlSlug: '',
    phone: '',
    email: '',
    photoUrl: '',
    companyName: '',
    companyWebsite: '',
    companyPhone: '',
    streetAddress: '',
    city: '',
    postalCode: '',
    province: '',
    languagePreference: null,
  },

  getters: {
    account(state) {
      return state;
    },

    advisorLink({ firstName, lastName, invitationUrlSlug }, { hasProfile }) {
      if (!hasProfile) return null;
      const path = [
        firstName.toLowerCase().replace(/[^a-z0-9\u00C0-\u00FF]/gi, ''),
        lastName.toLowerCase().replace(/[^a-z0-9\u00C0-\u00FF]/gi, ''),
        invitationUrlSlug,
      ]
        .filter(s => s)
        .join('-');
      return `${apiUrl.host}/advisor-invitation/${path}`;
    },

    hasProfile({
      email, firstName, lastName, phone,
    }) {
      return email.length > 0 && firstName.length > 0 && lastName.length > 0 && phone.length > 0;
    },
  },

  mutations: {
    updateAccount(state, data) {
      Object.assign(state, data);
    },

    updatePhotoUrl(state, url) {
      state.photoUrl = url;
    },
  },

  actions: {
    async fetchAccount({ commit }) {
      const account = await fetchAccount.execute();
      commit('updateAccount', account);
    },

    async updateAccount({ commit }, data) {
      const { account, emailExists } = await updateAccount.execute(data);
      if (emailExists) {
        throw new Error('emailExists');
      } else {
        commit('updateAccount', account);
      }
    },

    async updateDefaultFee({ commit }, data) {
      const { account } = await updateAccount.execute(data);
      commit('updateAccount', account);
    },

    async updateAdvisorPhoto({ commit }, { photoUrl }) {
      const result = await updateAdvisorPhoto.execute({ photoUrl });
      commit('updatePhotoUrl', result.photoUrl);
    },

    async deleteAdvisorPhoto({ commit }) {
      await deleteAdvisorPhoto.execute();
      commit('updatePhotoUrl', null);
    },
  },
};
